import successReducer from './successReducer';

export default successReducer;
